import { BaseModal } from 'components/modals/BaseModal';
import { Color } from 'core';
import { ISet } from 'models/set';
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AddContentToCourse } from './shared/AddContentToCourse';

interface IProps {
  contentItems: ISet[];
  excludedSurveyCount?: number;
  onClose: (didAddContent: boolean) => void;
}

export const AddToCourseModal = (props: IProps) => {
  const { contentItems, excludedSurveyCount = 0, onClose } = props;
  const { t } = useTranslation();
  const [hasAddedContent, setHasAddedContent] = useState(false);

  const handleAddSuccess = useCallback(() => {
    setHasAddedContent(true);
  }, []);

  const handleClose = useCallback(() => {
    onClose(hasAddedContent);
  }, [onClose, hasAddedContent]);

  const title =
    contentItems.length > 1
      ? `Add ${contentItems.length} assignments to Course`
      : `Add "${contentItems[0].name}" to Course`;

  return (
    <BaseModal title={title} onClose={handleClose}>
      <ModalContent>
        {excludedSurveyCount > 0 && (
          <SurveyNotice>
            {t('{{count}} survey(s) excluded. Surveys must be added to courses from the course detail page.', {
              count: excludedSurveyCount,
            })}
          </SurveyNotice>
        )}
        <AddContentToCourse contentItems={contentItems} onAddSuccess={handleAddSuccess} />
      </ModalContent>
    </BaseModal>
  );
};

const SurveyNotice = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
  padding: 12px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
`;

const ModalContent = styled.div`
  width: 80vw;
  height: 80vh;
  display: flex;
  flex-direction: column;
`;
